// extracted by mini-css-extract-plugin
export default {"content":"add-pop-up_content__99O8x","title":"add-pop-up_title__dkfFB","form":"add-pop-up_form__RfMkl"};